<template>
   
     <!-- Section: testimonial -->
    <section id="testimonial" class="home-section paddingbot-60 parallax">
      <div class="container">
      <slick
        ref="slick"
        :options="slickOptions" v-if="listVideo.length">
        <div v-for="videoObj in this.listVideo" v-bind:key="videoObj._id">
          <iframe width="375" height="260" :src="videoObj.link + '?autoplay=0&mute=0&enablejsapi=1'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        
         <!-- <a v-for="videoObj in this.listVideo" v-bind:key="videoObj._id" href="http://placehold.it/300x270"><img src="http://placehold.it/440x300" alt=""></a>-->
          <!--<div class="video-wrapper">
          
          </div>-->
        
      </slick>
      </div>
    </section>
    <!-- /Section: testimonial -->

</template>

<script>
import { getDataFromServerWithHeader, getDataFromServer } from '../utils/DataProvider';
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
  export default {
    components: { Slick },

    data: () => ({
        listVideo:[],
        slickOptions: {
                slidesToShow: 3,
                slidesToScroll: 1,
                
                centerMode: true,
                centerPadding:'0px',
                rtl: false,
                arrows:true,
                responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
              ]
            },
        
    }),
    methods:{
         getVideoList(){
          getDataFromServer('list_gallery_byplace', {mediatype:'video',place:'home_video_slider'})
          .then(obj => 
          {
            console.log("response success : ", obj.data.success);
            if(obj.data.success === true){
              console.log("response list_gallery: ", obj.data.data);              
              this.listVideo = obj.data.data;     
              console.log("response listVideo: ", this.listVideo); 
            }
            else{
              this.flash('get video slider error: ' + obj.data.text , 'error', {timeout: 4000})
            }          
          })
          .catch(err => {
            console.log("response : ", err);
            this.flash('get video slider error: ' + err, 'error', {timeout: 4000})
          })
        },
        
    },
    created(){
      this.getVideoList()
    }
  }
</script>

<style scoped>
.video-wrapper {
	position: relative;
	padding-bottom: 56.25%; /* 16:9 */
	padding-top: 25px;
	height: 0;
}
.video-wrapper iframe {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
</style>